import {ProductSorting} from "@app/core/product/domain/dtos/product-sorting.enum";

export const KEY_ALL_FILTERS = 'allfilters';
export const KEY_ALL_CATEGORIES = 'allcategories';
export const KEY_NO_SPECIAL_TYPE = 'notype';
export const KEY_EMPTY_QUERY = 'empty';
export const DEFAULT_SORTING = ProductSorting.TOP_PRODUCTS;
export const TOP_CATEGORY_CODE = '#';

export enum SpecialCategories {
    SPECIAL_INDIVIDUALS = 'P',
    TOP_PRODUCTS = 'T',
    NEW_PRODUCTS = 'N',
    PROMOTIONS = 'Z'
}

export enum QueryParamsKeys {
    QUERY = 'q',
    FILTERS = 'f',
    SORTING = 'o',
    PAGE_NUMBER = 'p',
}

export const CATEGORY_CODE_URL_PARAM_KEY = 'id';
